import {
  Search,
  Target,
  Megaphone,
  Share2,
  MonitorSmartphone,
  PenLine,
  ShoppingBag,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

export const BUSINESS_TYPES = [
  "Small Business",
  "Startup",
  "E-commerce Brand",
  "Real Estate Company",
  "Local Business",
  "Other",
];

export const SERVICES = [
  {
    icon: Target,
    title: "Google Ads",
    desc: "Create campaigns that bring targeted customers and quality leads with data-driven Google Ads strategies.",
  },
  {
    icon: Search,
    title: "SEO",
    desc: "Improve online visibility, increase rankings and attract organic traffic with powerful SEO strategies.",
  },
  {
    icon: Megaphone,
    title: "Meta Ads",
    desc: "Run high-performing Facebook and Instagram advertising campaigns that increase brand awareness and generate leads.",
  },
  {
    icon: Share2,
    title: "Social Media Marketing",
    desc: "Build a strong online presence through engaging content, strategy and audience growth.",
  },
  {
    icon: MonitorSmartphone,
    title: "Website Design & Development",
    desc: "Create fast, modern and conversion-focused websites that turn visitors into customers.",
  },
  {
    icon: PenLine,
    title: "Content Marketing",
    desc: "Create valuable content that builds trust, attracts audiences and supports long-term growth.",
  },
  {
    icon: ShoppingBag,
    title: "E-commerce Marketing",
    desc: "Scale your online store with conversion-focused funnels, product ads and remarketing strategies.",
  },
];

export const WHY_CHOOSE_US = [
  { num: "01", title: "Result Driven Strategies", desc: "Every campaign is built around measurable outcomes — leads, revenue, and ROI." },
  { num: "02", title: "Transparent Reporting", desc: "Clean dashboards and weekly insights so you always know where your spend goes." },
  { num: "03", title: "Dedicated Account Manager", desc: "A single point of contact who understands your brand and growth roadmap." },
  { num: "04", title: "Affordable Pricing", desc: "Premium digital marketing at fair, startup-friendly prices — no hidden fees." },
  { num: "05", title: "Customized Marketing Solutions", desc: "No cookie-cutter playbooks. We tailor strategy to your industry and audience." },
  { num: "06", title: "Lead Generation Focused", desc: "Proven systems that convert clicks into qualified leads — and leads into customers." },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Discovery", desc: "We understand your business goals, audience and challenges through a deep-dive consultation." },
  { num: "02", title: "Strategy", desc: "We craft a customized marketing plan mapped to your KPIs, channels and budget." },
  { num: "03", title: "Execution", desc: "We launch campaigns, SEO, content and website solutions with precision and pace." },
  { num: "04", title: "Optimization", desc: "We continuously improve performance using analytics, A/B testing and data insights." },
  { num: "05", title: "Reporting", desc: "We deliver transparent reports and growth updates — no jargon, just results." },
];

export const PORTFOLIO = [
  {
    title: "Real Estate Lead Engine",
    category: "Real Estate · Google + Meta Ads",
    stat: "3.2x lead volume in 60 days",
    img: "https://images.unsplash.com/photo-1542393545-10f5cde2c810?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxsYXB0b3AlMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGFya3xlbnwwfHx8fDE3ODI4MjYxMTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "D2C Skincare Scale-Up",
    category: "E-commerce · Meta Ads + SEO",
    stat: "4.6 ROAS · 220% organic growth",
    img: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsYXB0b3AlMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGFya3xlbnwwfHx8fDE3ODI4MjYxMTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Local Clinic Visibility",
    category: "Local Business · SEO + Google Ads",
    stat: "Page 1 for 38 high-intent keywords",
    img: "https://images.unsplash.com/photo-1604074131228-9d48b811bd80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGFya3xlbnwwfHx8fDE3ODI4MjYxMTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Startup Brand Launch",
    category: "SaaS Startup · Website + Content",
    stat: "From 0 to 12k monthly visitors",
    img: "https://images.pexels.com/photos/7055/desk-computer-imac-home.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const TESTIMONIALS = [
  {
    name: "Rajesh Patel",
    role: "Founder, Maple Interiors · Ahmedabad",
    quote:
      "DDigital Studios completely transformed our Google Ads. Within 3 months our cost per lead dropped by 41% and our calendar is full. Their reporting is the most honest I’ve ever seen.",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4MjgyNjExN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Sneha Mehta",
    role: "Co-founder, Bloom & Botanicals (D2C)",
    quote:
      "Our Meta Ads were burning cash before we partnered with DDigital. Now we hit 4.6 ROAS consistently and our Instagram has become a real growth channel. Worth every rupee.",
    img: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4MjgyNjExN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Arjun Shah",
    role: "Director, Skyline Realty",
    quote:
      "We were sceptical about digital marketing for real estate. The DDigital team delivered qualified site visits in the first 30 days. Their account manager is genuinely invested in our growth.",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4MjgyNjExN3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "What digital marketing services does DDigital Studios offer?",
    a: "We offer a full suite of digital marketing services including Google Ads, SEO, Meta Ads (Facebook & Instagram), social media marketing, website design & development, content marketing and e-commerce marketing — all under one roof, managed by a dedicated account manager.",
  },
  {
    q: "How are Google Ads campaigns structured at DDigital?",
    a: "Every Google Ads engagement begins with deep keyword research, competitor analysis and conversion tracking setup. We then build search, performance max and remarketing campaigns mapped to your funnel — followed by weekly optimization to lower CPL and scale ROAS.",
  },
  {
    q: "How long does SEO take to show results?",
    a: "Most clients see meaningful movement in keyword rankings and organic traffic within 3–4 months, with compounding growth from month 6 onwards. We share transparent monthly reports covering rankings, traffic, backlinks and on-page progress.",
  },
  {
    q: "Do you manage Meta Ads (Facebook & Instagram) for both leads and e-commerce?",
    a: "Yes. We run lead-generation campaigns for service businesses (real estate, clinics, coaches) and full-funnel e-commerce campaigns (prospecting, retargeting, catalogue ads) for D2C brands — with creative, copy and pixel/CAPI setup handled in-house.",
  },
  {
    q: "Do you build websites? What does Website Design & Development include?",
    a: "We design and develop fast, mobile-first, SEO-friendly websites on modern stacks. Every site includes conversion-focused UX, on-page SEO, analytics setup, and Google/Meta pixel integration so it’s ready to scale ads from day one.",
  },
  {
    q: "How much do your digital marketing services cost?",
    a: "Our retainers are designed to be affordable for small businesses while still being premium. The Starter Growth plan is best for local businesses; Business Growth suits scaling brands; Enterprise is custom-built. Book a free consultation for an exact quote based on your goals.",
  },
  {
    q: "Will I get a dedicated account manager?",
    a: "Yes. Every client gets a single dedicated account manager who is your point of contact across all services. They run weekly check-ins, share reports and act as an extension of your marketing team.",
  },
  {
    q: "How do you report results and ROI?",
    a: "We provide a transparent live dashboard plus a monthly performance report covering spend, leads, CPL, ROAS, organic traffic and rankings — along with insights and next-month strategy. No vanity metrics.",
  },
  {
    q: "Is the free consultation actually free?",
    a: "Yes — completely free. You’ll get a 30-minute strategy call where we audit your current marketing, identify quick wins and recommend a roadmap. No obligation to sign up afterwards.",
  },
  {
    q: "Do you only work with businesses in Ahmedabad?",
    a: "We’re headquartered in Ahmedabad, Gujarat, but we serve clients across India and a few international markets. All collaboration is handled remotely with regular video reviews.",
  },
];

export const PRICING = [
  {
    name: "Starter Growth",
    tagline: "For local businesses & solo founders",
    price: "₹24,999",
    period: "/ month",
    features: [
      "Google Ads OR Meta Ads (1 channel)",
      "Basic SEO — up to 10 keywords",
      "2 social media platforms managed",
      "8 social posts / month",
      "Monthly performance report",
      "Dedicated account manager",
    ],
    highlighted: false,
  },
  {
    name: "Business Growth",
    tagline: "For scaling brands & e-commerce",
    price: "₹54,999",
    period: "/ month",
    features: [
      "Google Ads + Meta Ads (multi-channel)",
      "Advanced SEO — up to 30 keywords",
      "3 social platforms managed",
      "16 social posts + 4 reels / month",
      "Content marketing (4 blogs / month)",
      "Bi-weekly strategy calls",
      "Conversion rate optimization",
    ],
    highlighted: true,
  },
  {
    name: "Enterprise",
    tagline: "Custom-built for ambitious brands",
    price: "Custom",
    period: "Tailored quote",
    features: [
      "Unlimited channels & full-funnel ads",
      "Enterprise SEO & technical audits",
      "Website design & development included",
      "Daily campaign optimization",
      "Senior strategist + dedicated team",
      "Custom dashboards & API integrations",
      "Priority support & SLA",
    ],
    highlighted: false,
  },
];

export const CONTACT = {
  email: "hello@ddigitalstudios.in",
  phone: "+91 98765 43210",
  address: "Ahmedabad, Gujarat, India",
  website: "www.ddigitalstudios.in",
  socials: {
    instagram: "https://instagram.com/",
    linkedin: "https://linkedin.com/",
    facebook: "https://facebook.com/",
    youtube: "https://youtube.com/",
  },
};
